import { success } from "../../Helpers/notification";
import { postRequest } from "../apiMethods";
import { apiRoutes } from "../apiRoutes"

import moment from 'moment';
const { emailOn, dynamicAdjustments, alerts,kpis } = apiRoutes;

const onRejectionSubmit = async (body = {}) => {
    let onEmail = await postRequest({
        endPoint: emailOn.rejection,
        body: body.emailOnRejection
    })
    let createDY = await postRequest({
        endPoint: dynamicAdjustments.create,
        body: body.DYCreate
    })
    let createLog = await postRequest({
        endPoint: alerts.create,
        body: body.logsCreate
    })
    const time = moment(new Date()).toDate();
    let bodyData = {
        productionLineId:body.DYCreate?.lineId,
        time,
        machine: body.DYCreate?.machine,
        statsGenerate:true,
    }
    let response = await postRequest({
        endPoint: kpis.generateStats,
        body:bodyData
    })
    if (onEmail.success && createDY.success && createLog.success) {
        success("Rejection Added")
    }

}

const onReworkSubmit = async (body = {}) => {
    let onEmail = await postRequest({
        endPoint: emailOn.rework,
        body: body.emailOnRework
    })
    let createDY = await postRequest({
        endPoint: dynamicAdjustments.create,
        body: body.DYCreate
    })
    let createLog = await postRequest({
        endPoint: alerts.create,
        body: body.logsCreate
    })
    const time = moment(new Date()).toDate();
    let bodyData = {
        productionLineId:body.DYCreate?.lineId,
        time,
        machine: body.DYCreate?.machine,
        statsGenerate:true,
    }
    let response = await postRequest({
        endPoint: kpis.generateStats,
        body:bodyData
    })
    if (onEmail.success && createDY.success && createLog.success) {
        success("Rework Added")
    }

}

export {
    onRejectionSubmit,
    onReworkSubmit
}